import { ReactNode, FC } from 'react';

interface IConditionalWrapperProps {
  if: boolean;
  with: (children: ReactNode) => JSX.Element;
  children: ReactNode;
}

export const ConditionalWrapper: FC<IConditionalWrapperProps> = ({
  if: condition,
  with: wrapper,
  children,
}) => {
  return condition ? wrapper(children) : <>{children}</>;
};
